export default{
  setProjects: (state, payload) => {state.projects = payload},
  setProject: (state, payload) => {state.project = payload},
}